<template>
    <div class="container">
        <el-row :gutter="20">
            <el-col>
                <div>
                    <el-row :gutter="24">
                        <el-col >
                            <div class="title"> <strong>{{getTitle(type)}}</strong> </div>
                        </el-col>
                    </el-row>
                    <div class="buttonContainer">
                        <el-row justify="end" type="flex" :gutter="24"> <!-- Niso vredu poravnani, delete button je prevec narazen od drugih dveh -->
                            <el-col :lg="3" :md="4" :sm="5" :xs="24">
                                <el-button class="button"  @click="Delete()"> {{$l('archives/Delete')}} </el-button>
                            </el-col>
                            <el-col :lg="3" :md="4" :sm="5" :xs="24"> 
                                <el-button class="button"  @click="Download()"> {{$l('archives/Download')}} </el-button>
                            </el-col>
                            <!--el-col :lg="3" :md="4" :sm="5" :xs="24">
                                <el-button v-if="type=='noise'" class="button"> {{$l('archives/NorReview')}}  </el-button>
                            </el-col-->
                        </el-row>
                    </div>
                    <!-- Days -->
                    <div class="containerArchive" v-if="!isHours">
                        <el-row class="firstRow" :gutter="25">
                            <el-col style="position:absolute"> <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllDays" @change="handleCheckAllChange"></el-checkbox></el-col>
                            <el-col :xs="6" :sm="4" :md="3" :lg="2"> &nbsp; </el-col>
                            <el-col :span="8"> {{$l('archives/Filename')}} <div  @click="sortDaysByName"  class="filter-icon"><icon  name="chevron-down"> </icon></div> </el-col>
                        </el-row>
                        <el-checkbox-group v-model="checkedDays" @change="handleCheckedChange">
                            <el-row class="dayRow" v-for="(day, index) in days" v-bind:key="index" :gutter="25">
                                <el-col :xs="6" :sm="4" :md="3" :lg="2"> <el-checkbox :label="day" :key="index" class="checkbox-label"> </el-checkbox> </el-col> 
                                <el-col :xs="9" :sm="7" :md="6" :lg="6" v-if="!isGlobalValues && !isCompressed"> <div @click="goTo(day)"> {{day}} </div> </el-col>
                                <el-col :xs="9" :sm="7" :md="6" :lg="6" v-if="isGlobalValues || isCompressed"> <div @click="downloadHour(day)"> {{day}} </div> </el-col>
                            </el-row>
                        </el-checkbox-group>
                    </div>
                    <!-- Hours -->
                    
                    <div class="containerArchive" v-if="isHours">
                        <el-row v-if="isHours && (isAudio || isVideo)" class="firstRow" :gutter="25">
                            <el-col style="position:absolute; width:20px"> <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllHours" @change="handleCheckAllChange" class="checkbox-label"></el-checkbox></el-col>
                            <el-col style="margin-left:25px; position:absolute; width:20px" ><i @click="goParentClicked" class="el-icon-caret-left go-parent"></i>  </el-col>
                            <el-col :xs="6" :sm="3" :md="4" :lg="3" :offset="2"> {{$l('archives/Thumbnail')}}</el-col>
                            <el-col :xs="9" :sm="8" :md="8" :lg="7" > {{$l('archives/Filename')}} <div  @click="sortHoursByName"  class="filter-icon"><icon  name="chevron-down"> </icon></div></el-col>
                            <el-col :xs="6" :sm="3" :md="3" :lg="3"> {{$l('archives/Size')}} <div  @click="sortHoursBySize"  class="filter-icon"><icon  name="chevron-down"> </icon></div> </el-col>
                            <el-col v-if="isVideo && false" :xs="2" :sm="6" :md="6" :lg="6"> {{$l('archives/Duration')}} <div  @click="sortHoursByDuration"  class="filter-icon"><icon  name="chevron-down"> </icon></div> </el-col>
                        </el-row>
                        <el-row v-else class="firstRow" :gutter="25">
                            <el-col style="position:absolute;  width:20px"> <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllHours" @change="handleCheckAllChange" class="checkbox-label"></el-checkbox></el-col>
                            <el-col style="margin-left:25px; position:absolute;  width:20px" ><i @click="goParentClicked" class="el-icon-caret-left go-parent"></i>  </el-col>

                            <el-col :xs="12" :sm="8" :md="8" :lg="6" :offset="3"> {{$l('archives/Filename')}} <div  @click="sortHoursByName"  class="filter-icon"><icon  name="chevron-down"> </icon></div> </el-col>
                            <el-col :xs="6" :sm="4" :md="4" :lg="3"> {{$l('archives/Size')}} <div  @click="sortHoursBySize"  class="filter-icon"><icon  name="chevron-down"> </icon></div> </el-col>
                        </el-row>
                        <el-checkbox-group v-if="isHours&& (isAudio || isVideo)" v-model="checkedHours">
                            <!-- Open thumbnail to view bigger picture -->
                            <el-dialog
                                :title="$l('archives/Thumbnail')"
                                :visible.sync="thumbnailVisible"
                                size="auto"
                                >
                                <span slot="footer" class="dialog-footer">
                                        <img :src="this.Image">
                                        <el-button @click=" thumbnailVisible=  false"> {{$l('archives/Close')}}  </el-button>
                                </span>
                            </el-dialog>

                            <audio-download-dialog v-bind:data="audioDownloadDialog"> </audio-download-dialog>

                            <el-row class="dayRow" v-for="(hour, index) in filterHours" v-bind:key="index" :gutter="25">
                                <el-col :xs="2" :sm="2" :md="2" :lg="2"> <el-checkbox :key="index" :label="hour[0]"  class="checkbox-label"> </el-checkbox> </el-col>
                                
                                <el-col v-if="isAudio" :xs="3" :sm="3" :md="4" :lg="3"> <img @click="thumbnailVisible = true, setImageAudio(day, hour[0])" class="thumbnails" :src="'/audio/audio/'+ day +'/thumbnails/' + fileNameToPng(hour[0])">&nbsp; </img> </el-col>
                                <el-col v-if="isVideo" :xs="3" :sm="3" :md="4" :lg="3"> <img @click="thumbnailVisible = true, setImageVideo(day, hour[0])" class="thumbnails" :src="'/video/video/'+ day +'/thumbnails/' + fileNameToPng(hour[0])">&nbsp; </img> </el-col>

                                <el-col v-if="isAudio" :xs="15" :sm="8" :md="8" :lg="7"> <div class="text" @click="openDownloadAudioDialog(hour)"> {{hour[0]}} <icon name="download"> </icon></div> </el-col>
                                <el-col v-if="isVideo" :xs="15" :sm="8" :md="8" :lg="7"> <div @click="downloadHour(hour)"> {{hour[0]}} </div> </el-col>
                                
                                <el-col v-if="isAudio" :xs="2" :sm="3" :md="4" :lg="3"> <div class="text"> {{hour[1]}} </div> </el-col>
                                <el-col v-if="isVideo" :xs="2" :sm="3" :md="4" :lg="3"> <div> {{hour[1]}} </div> </el-col>

                                <el-col v-if="isVideo" :xs="2" :sm="6" :md="6" :lg="6"> <div> 
                                    <!--<video class="audioControls" controls="controls" preload="none" > 
                                        <source :src="'/video/video/'+ day +'/' + hour[0]"  type="video/avi">
                                    </video>-->
                                    <!--<video-player v-bind:src="'/video/video/'+ day +'/' + hour[0]"  type="video/mp4"></video-player>-->
                                </div></el-col>
                                <el-col v-if="isAudio" :xs="24" :sm="8" :md="6" :lg="9">
                                    <audio-player v-bind:src="'/audio/audio/'+ day +'/' + hour[0]"></audio-player>
                                </el-col>
                            </el-row>
                        </el-checkbox-group>
                        <el-checkbox-group v-else v-model="checkedHours"> <!-- Everything else -->
                            <el-row class="dayRow" v-for="(hour, index) in filterHours" v-bind:key="index" :gutter="25">
                                <el-col :xs="2" :sm="2" :md="2" :lg="2" > <el-checkbox :key="index" :label="hour[0]" class="checkbox-label"> </el-checkbox> </el-col> 
                                <el-col :xs="15" :sm="8" :md="8" :lg="6"> <div @click="downloadHour(hour)"> {{hour[0]}} </div> </el-col>
                                <el-col :xs="4" :sm="4" :md="4" :lg="3"> <div> {{hour[1]}} </div> </el-col>
                            </el-row>
                        </el-checkbox-group>
                        <div class="pagination-bar">
                            <el-button-group v-if="hours.length > 24">
                                <el-button @click="paginationBackClicked" v-bind:disabled="hoursOffset == 0" size="small" type="primary" icon="arrow-left">BACK</el-button>
                                <el-button @click="paginationNextClicked" :disabled="filterHours.length<24" size="small" type="primary">NEXT <i class="el-icon-arrow-right el-icon-right"></i></el-button>
                            </el-button-group>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<style scoped>
    .checkbox-label{
        width:20px;
        overflow: hidden;
    }
    .el-dialog{
        background:#364150;
    }
    .text{
        text-align:left;
        margin-top:20px;
        width:100%;
    }
    .el-checkbox{
        color:transparent;
    }
    .title{
        text-align:center;
        font-size:30px;
        padding:12px;
    }
    .container{
        padding-top:25px;
        position:relative;
    }
    .containerArchive{
        margin-left: 25px;
        margin-right: 25px;
        padding-left:11px;
        padding-right:12px;
        border: 1px solid #e1e5ec;
    }
    .buttonContainer{
        margin-left: 25px;
        margin-right: 25px;
        padding-bottom:10px;
    }
    .button{
        width:100px;
        float:right;
    }
    .firstRow{
        padding-left:4px;
        padding-bottom:10px;
        padding-top:10px;
        background:#2C3E50;
        color:white;
    }
    .dayRow{
        padding:4px;
        background:#FAFAFA;
    }
    .dayRow:nth-child(odd){
        background:#E9EDEF;
    }
    .thumbnails{
        float:left;
        max-width:100%;
    }
    .audioControls{
        width:100%;
        margin-top:10px;
        border: 1px solid #e1e5ec;
    }
    .go-parent:hover{
        color: #1BBC9B;
    }
    .filter-icon{
        position: absolute;
        margin-left:5px;
        margin-top: -2px;
            display: inline-block;
    }
    .filter-icon:hover{
        color: #1BBC9B;
        
    }

    .pagination-bar{
        text-align: center;
        margin-top:10px;
        margin-bottom:10px;
    }
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import { state } from 'vuex'
import {getDaysByType, getHoursByType , postFileAction, getFilesAction} from '@/store/actions';

//Components
import AudioDownloadDialog from '@/components/archives/AudioDownloadDialog';
import AudioPlayer from '@/components/archives/AudioPlayer';
import VideoPlayer from '@/components/archives/VideoPlayer';

import * as api from '@/api'

// #E9EDEF #E5E5E5
export default {
    data:function(){
        return{
            Image: "",
            thumbnailVisible: false,
            downloadPart: false,
            visible:false,
            checkAllDays: false,
            checkAllHours: false,
            isIndeterminate: false,
            checkedDays:[],
            checkedHours:[],
            days:[],
            hours:[],
            manualOn: 0,
            startTime: -1,
            stopTime: -1,
            audioDownloadDialog:{
                visible:false,
                length:10,
                selection:[0,0]
            },
            hoursOffset: 0,
        }
    },
    components:{
        'audio-download-dialog':AudioDownloadDialog,
        'audio-player':AudioPlayer,
        'video-player':VideoPlayer
    },
    computed:{
        type: function(){
            return this.$route.params.type;
        },
        day: function(){
            return this.$route.params.day;
        },
        isHours: function(){
            if(this.$route.params.day){
                return true;
            }
            return false;
        },
        isAudio: function(){
            if(this.$route.params.type == 'audio'){
                return true;
            }
            return false;
        },
        isVideo: function(){
            if(this.$route.params.type == 'video'){
                return true;
            }
            return false;
        },
        isCompressed: function(){return this.$route.params.type == 'compressed'},
        isGlobalValues: function(){return this.$route.params.type == 'global'},
        ...mapGetters([
           'getSettingsDevice',
           'getSettingsWeather',
           'getLocalSettings'
        ]),
        filterHours: function(){
            return this.hours.slice(this.hoursOffset*24,(this.hoursOffset+1)*24);
        }
    },
    methods:{
        ...mapActions([
            'setDownloading',
            'setDownloadingProgress'
        ]),
        goTo(day){
            this.hours = [];
            this.$router.push("/archives/" + this.type + "/"  + day);
            this.isIndeterminate = false;
        },
        handleCheckAllChange(event){
            if(this.isHours){
                this.checkedHours =  event.target.checked ? this.hours.map(h=>h[0]) : [];                    
                this.isIndeterminate = false;
            }
            else{
                this.checkedDays =  event.target.checked ? this.days : [];
                this.isIndeterminate = false;
            }
        },
        fileNameWithoutType(filename){
            return filename.substring(0,filename.length-4);
        },
        fileNameToPng(filename){
            if(this.isAudio) {
                return filename.substring(0,filename.length-4)+".png";
            }
            else if(this.isVideo)
                return filename.substring(0,filename.length-4)+".png";
        },
        getTitle(title){
            return this.$l("archives/" + title);
        },
        handleCheckedChange(value) { //preimenuj v primeru da se spet uporabu
            //ne dela za ure
            if(this.isHours){
                let checkedCount = value.length;
                this.checkAllHours = checkedCount === this.hours.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.hours.length;
            }
            else{
                let checkedCount = value.length;
                this.checkAllDays = checkedCount === this.days.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.days.length;
            }
        },
        downloadHour(hour){
            var url = "";
            var device = this.getSettingsDevice.valsel.join(',');
            var weather = this.getSettingsWeather.valsel.filter(val=>val.enabled).map(val=>val.name).join(',');
            var newHour= hour[0].substring(0 , hour[0].indexOf('.'));
            
            switch(this.type){
                case 'global':url = "/api/download-global&measurement=" + hour + "&param=L1,L5,L10,L50,L90,L95,L99,LAEQ&zip=" + this.getLocalSettings.interface.compress+'&time='+Date.now(); break;
                case 'compressed':url = "/api/file-action&&action=download&type="+ this.type +"&files=" + hour +'&time='+Date.now(); break;
                default: url="/api/file-action&&action=download&type="+ this.type +"&files="+ newHour +'&time='+Date.now(); break;
            }
            
            this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'GET','', (progress)=>{
                    let percentage = Math.round((progress.loaded/progress.total)*100);
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
        },
        openDownloadAudioDialog(hour){
            let lengthSplit =  hour[2].split(':');
            let length = parseInt(lengthSplit[0])* 60 * 60 + parseInt(lengthSplit[1])*60+ parseInt(lengthSplit[2]);
            this.audioDownloadDialog.name = hour[0];
            this.audioDownloadDialog.length  = length;
            this.audioDownloadDialog.visible = true;
            this.audioDownloadDialog.selection = [0, length];
        },
        downloadPartHour(){
            //case 'audio': url="/api/file-action&&action=download&type="+ this.type +"&files="+ newHour + ".mp3"; break;
        },
        Delete(){
            var data = {}
            var previouslyChecked = [];
            if(!this.isHours){
                previouslyChecked = this.checkedDays;
                if (this.isCompressed) {
                    data.data = this.checkedDays.map(item=>item);
                } else {
                    data.data = this.checkedDays.map(item=>item.split('.')[0]);
                }
            }else{
                previouslyChecked = this.checkedHours;
                if (this.isCompressed) {
                    data.data = this.checkedHours.map(item=>item);
                } else {
                    data.data = this.checkedHours.map(item=>item.split('.')[0]);
                }
            }
            
            postFileAction(this.$store,'delete', this.type, data)
                .then(_=>{
                    if(!this.isHours){
                        data.data.forEach(date=>{
                            var index = this.days.indexOf(date);
                            if(index > -1)
                                this.days.splice(index,1);
                        })
                    }else{
                        data.data.forEach(date=>{
                            var mapped = this.hours.map(d=>JSON.stringify(d));
                            var index = mapped.indexOf(mapped.find(i=>i.indexOf(date)>-1));
                            if(index > -1)
                                this.hours.splice(index,1);
                        })
                    }
            });
            
        },
        Download(){
            var data = [];
            if(!this.isHours){
                data= this.checkedDays.join(',');
            }else{
                data=  this.checkedHours.join(',');
            }
            var url="/api/file-action&&action=download&type="+ this.type +"&files="+ data+'&time='+Date.now();
            
            this.setDownloading({enabled: true, progress: 0, preparing:true})
            api.getFileAction(url,'GET','', (progress)=>{
                let percentage = Math.round((progress.loaded/progress.total)*100);
                this.setDownloadingProgress(percentage);
            })
            .then(()=>{
                this.setDownloading({enabled: false, progress: 0})
            })
            .catch(()=>{
                this.setDownloading({enabled: false, progress: 0})
                
            })
            //window.location.href = url;

            this.checkedDays = [];
            this.checkedHours = [];
        },
        setImageAudio(day, hour){
            this.Image = "/audio/audio/" + day + "/" + this.fileNameToPng(hour);
        },
        setImageVideo(day, hour){
            this.Image = "/video/video/" + day + "/" + this.fileNameToPng(hour);
        },
        goParentClicked(){
             this.$router.push("/archives/" + this.type+'/');
             this.isIndeterminate = false;
        },
        sortDaysByName(){
            if(this.days.length == 0) return;

            var oldStart = this.days[0]
            this.days = this.days.sort((a,b)=>{
                return a< b ? -1 : a > b;
            });
            if(oldStart == this.days[0])
                this.days = this.days.reverse();
        },
        sortHoursByName(){
            if(this.hours.length == 0) return;

            var oldStart = this.hours[0][0]
            this.hours = this.hours.sort((a,b)=>{
                return a[0] < b[0] ? -1 : a[0] > b[0];
            });
            if(oldStart == this.hours[0][0])
                this.hours = this.hours.reverse();
        },
        sortHoursBySize(){
            if(this.hours.length == 0) return;

            var oldStart = this.hours[0][1]
            this.hours = this.hours.sort((a,b)=>{
                return a[1] < b[1] ? -1 : a[1] > b[1];
            });
            if(oldStart == this.hours[0][1])
                this.hours = this.hours.reverse();
        },
        sortHoursByDuration(){
            if(this.hours.length == 0) return;

            var oldStart = this.hours[0][2]
            this.hours = this.hours.sort((a,b)=>{
                return a[2] < b[2] ? -1 : a[2] > b[2];
            });
            if(oldStart == this.hours[0][2])
                this.hours = this.hours.reverse();
        },
        paginationBackClicked(){
            this.hoursOffset = this.hoursOffset-1;
        },
        paginationNextClicked(){
            this.hoursOffset = this.hoursOffset+1;
        }
    },
    watch:{
        type:function(newType){

            getDaysByType(this.$store, newType)
                .then(data=>{
                    this.days = data.data[newType];
                })
                .catch(()=>{
                    this.days = [];
                })
                this.checkedDays = [];
                this.checkedHours = [];
        },
        day:function(newDay){
            if(!newDay) return
            var day = new Date(newDay);
            getHoursByType(this.$store, this.type, day)
            .then(data=>{
                if(this.type == "audio")
                    this.hours = data.data;
                else
                    this.hours = data.data;
            })
            .catch(()=>{
                    this.hours = [];
            })
            this.checkedDays = [];
            this.checkedHours = [];
            this.hoursOffset = 0;
        },
        thumbnailVisible:function(){
            if(!this.thumbnailVisible){
                this.image = "";
            }
        },
        downloadPart:function(){
            if(!downloadHour){
                startTime = 0;
                stopTime = 0;
            }
        }

    },
    mounted: function(){
        if(!this.$p('archives')){
            this.$router.push('/');
            return;
        }
        if(this.day){
            var day = new Date(this.day);
            getHoursByType(this.$store, this.type, day)
            .then(data=>{
                if(this.type == "audio")
                    this.hours = data.data;
                else
                    this.hours = data.data;
            })
            .catch(()=>{
                    this.hours = [];
            })
        }
        else{
            var newType = this.type;
            getDaysByType(this.$store, newType)
            .then(data=>{
                this.days = data.data[newType];
            })
            .catch(()=>{
                    this.days = [];
            })
        }
        
    }
}
</script>


// WEBPACK FOOTER //
// Archive.vue?e2d15dbe